// The games the app plays. A script's id is the server's (`trouble_brewing`); its slug is the same
// with dashes, for the per-game pages: /how-to-play/bad-moon-rising, /roles/bad-moon-rising.

export const DEFAULT_SCRIPT_ID = "trouble_brewing";

export function scriptSlug(id: string): string {
  return id.replace(/_/g, "-");
}

export function scriptIdFromSlug(slug: string | undefined): string {
  return slug ? slug.replace(/-/g, "_") : DEFAULT_SCRIPT_ID;
}

export function howToPlayPath(id: string): string {
  return `/how-to-play/${scriptSlug(id)}`;
}

export function rolesPath(id: string): string {
  return `/roles/${scriptSlug(id)}`;
}
